import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "advertising-item__preview" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "advertising-item__content" }
const _hoisted_4 = { class: "advertising-item__header" }
const _hoisted_5 = { class: "advertising-item__badge" }
const _hoisted_6 = {
  key: 0,
  class: "advertising-item__appid"
}
const _hoisted_7 = ["title"]
const _hoisted_8 = { class: "advertising-item__actions" }

import { useApi } from '@/hooks/useApi';
import { useBaseAsync } from 'hpsfir-managebase-ui';
import { ref } from 'vue';
import { ElMessage } from 'element-plus';


export default /*@__PURE__*/_defineComponent({
  __name: 'AdvertisingItem',
  props: {
    data: {},
    isH: { type: Boolean },
    isFirst: { type: Boolean },
    isLast: { type: Boolean }
  },
  emits: ['change'],
  setup(__props: any, { emit: __emit }) {

const loading = ref(false);
const deleteDialogVisible = ref(false);

const props = __props;

const emits = __emit;

function withTimeout<T>(promise: Promise<T>, message = '广告操作超时') {
  return Promise.race([
    promise,
    new Promise<T>((resolve, reject) => {
      void resolve;
      window.setTimeout(() => reject(new Error(message)), 15000);
    }),
  ]);
}

const move = useBaseAsync(async(type: 'up' | 'down') => {
  try {
    loading.value = true;
    await withTimeout(useApi().advertisingApi.moveAdvertisingadvertising({
      advertisingId: props.data.id,
      up: type === 'up',
    }));
    emits('change');
  } catch (error) {
    console.log(error);
    ElMessage.error(error instanceof Error ? error.message : '移动广告失败');
  } finally {
    loading.value = false;
  }
});

const openDeleteDialog = () => {
  deleteDialogVisible.value = true;
};

const confirmDelete = async() => {
  try {
    loading.value = true;
    await withTimeout(useApi().advertisingApi.delAdvertisingadvertising(props.data.id), '删除广告超时');
    deleteDialogVisible.value = false;
    ElMessage.success('删除成功');
    emits('change');
  } catch (error) {
    console.log(error);
    ElMessage.error(error instanceof Error ? error.message : '删除广告失败');
  } finally {
    loading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_ArrowUpBold = _resolveComponent("ArrowUpBold")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_HpsfirButton = _resolveComponent("HpsfirButton")!
  const _component_ArrowDownBold = _resolveComponent("ArrowDownBold")!
  const _component_ArrowLeftBold = _resolveComponent("ArrowLeftBold")!
  const _component_ArrowRightBold = _resolveComponent("ArrowRightBold")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_HpsfirProDrawer = _resolveComponent("HpsfirProDrawer")!

  return (_openBlock(), _createElementBlock("article", {
    class: _normalizeClass(["advertising-item", loading.value ? 'advertising-item--loading' : ''])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: `${_unref(useApi)().baseUrl}${__props.data.image}`,
        alt: "广告图片"
      }, null, 8, _hoisted_2)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("span", _hoisted_5, _toDisplayString(__props.data.type === 'weapp' ? '小程序' : '公众号文章'), 1),
        (__props.data.appid)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, "appid: " + _toDisplayString(__props.data.appid), 1))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", {
        class: "advertising-item__url",
        title: __props.data.url
      }, " URL/Path：" + _toDisplayString(__props.data.url || '-'), 9, _hoisted_7)
    ]),
    _createElementVNode("div", _hoisted_8, [
      (!__props.isH && !__props.isFirst)
        ? (_openBlock(), _createBlock(_component_HpsfirButton, {
            key: 0,
            variant: "ghost",
            size: "sm",
            onClick: _cache[0] || (_cache[0] = () => _unref(move)('up'))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ArrowUpBold)
                ]),
                _: 1
              }),
              _cache[6] || (_cache[6] = _createTextVNode(" 前移 ", -1))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (!__props.isH && !__props.isLast)
        ? (_openBlock(), _createBlock(_component_HpsfirButton, {
            key: 1,
            variant: "ghost",
            size: "sm",
            onClick: _cache[1] || (_cache[1] = () => _unref(move)('down'))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ArrowDownBold)
                ]),
                _: 1
              }),
              _cache[7] || (_cache[7] = _createTextVNode(" 后移 ", -1))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (__props.isH && !__props.isFirst)
        ? (_openBlock(), _createBlock(_component_HpsfirButton, {
            key: 2,
            variant: "ghost",
            size: "sm",
            onClick: _cache[2] || (_cache[2] = () => _unref(move)('up'))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ArrowLeftBold)
                ]),
                _: 1
              }),
              _cache[8] || (_cache[8] = _createTextVNode(" 前移 ", -1))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (__props.isH && !__props.isLast)
        ? (_openBlock(), _createBlock(_component_HpsfirButton, {
            key: 3,
            variant: "ghost",
            size: "sm",
            onClick: _cache[3] || (_cache[3] = () => _unref(move)('down'))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ArrowRightBold)
                ]),
                _: 1
              }),
              _cache[9] || (_cache[9] = _createTextVNode(" 后移 ", -1))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "advertising-item__action-btn advertising-item__action-btn--danger",
        type: "button",
        onClick: _withModifiers(openDeleteDialog, ["stop"])
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_Delete)
          ]),
          _: 1
        }),
        _cache[10] || (_cache[10] = _createTextVNode(" 删除 ", -1))
      ])
    ]),
    _createVNode(_component_HpsfirProDrawer, {
      open: deleteDialogVisible.value,
      "onUpdate:open": _cache[5] || (_cache[5] = ($event: any) => ((deleteDialogVisible).value = $event)),
      title: "删除广告",
      width: "420px",
      "max-width": "calc(100vw - 32px)"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_HpsfirButton, {
          variant: "outline",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (deleteDialogVisible.value = false))
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
            _createTextVNode("取消", -1)
          ]))]),
          _: 1
        }),
        _createVNode(_component_HpsfirButton, {
          variant: "destructive",
          loading: loading.value,
          onClick: confirmDelete
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
            _createTextVNode("确定删除", -1)
          ]))]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _cache[13] || (_cache[13] = _createElementVNode("div", { class: "advertising-item__delete-confirm" }, [
          _createElementVNode("div", { class: "advertising-item__delete-title" }, "确定要删除这条广告吗？"),
          _createElementVNode("div", { class: "advertising-item__delete-desc" }, "删除后无法恢复，请谨慎操作。")
        ], -1))
      ]),
      _: 1
    }, 8, ["open"])
  ], 2))
}
}

})